<template>
  <div>
    <table-layout
      pkField="id"
      :selected.sync="selected"
      :loading="serversLoading"
      :items="listItems"
      :columns="columns"
      :addOptions="['addNew']"
      @click:addNew="addListItem"
      @open-modal="openUpdateModal"
    >
      <template #actions>
        <b-dropdown-item @click="openDialogRemove" aria-role="listitem">{{ $t('lists.deleteDetail') }}</b-dropdown-item>
      </template>
    </table-layout>
    <b-modal
      :active.sync="isUpdateItem"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-modal
      class="item-modal-layout"
    >
      <div class="modal-card" style="width: auto">
        <section class="modal-card-body">
          <h1>{{ $t('lists.updateItem') }}</h1>
          <parametrs-list :items.sync="updateItemData" :parameters="updateItemFields"> </parametrs-list>
          <edit-button v-if="!isUpdateItemLoading" :editOptions="['save']" @click="saveItem(updateItemData)">
            <template>
              <span class="text">{{ $t('button.save') }}</span>
            </template>
          </edit-button>
          <loader v-else></loader>
        </section>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import TableLayout from '@/layout/TableLayout'
import Loader from '@/components/Loader'
import ParametrsList from '@/components/ParametrsList'
import EditButton from '@/components/EditButton'

const { mapState: mapUserState } = createNamespacedHelpers('general')

export default {
  name: 'ListsItems',
  components: {
    TableLayout,
    Loader,
    ParametrsList,
    EditButton
  },
  mounted() {
    this.refetch()
  },
  computed: {
    ...mapUserState({
      role: state => state.user.role
    }),
    isAdmin() {
      return this.role === 'ADMIN'
    }
  },
  data() {
    return {
      listItems: [],
      isUpdateItem: false,
      isUpdateItemLoading: false,
      updateItemData: {},
      updateItemFields: [],
      listConfig: {},
      serversLoading: false,
      listItemsTypes: [],
      columns: [],
      selected: []
    }
  },
  methods: {
    ...mapActions('general', ['setTitle', 'setListName']),
    addListItem() {
      this.isUpdateItem = true
      this.updateItemData = {}
    },
    openUpdateModal(item) {
      this.isUpdateItem = true
      this.updateItemData = item.value
    },
    saveItem(item) {
      this.isUpdateItemLoading = false
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/list/items`
      fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          list_id: this.$route.params.list_id,
          list_item: item
        }),
        method: 'POST'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(() => {
          this.$notify({
            message: this.$t('notification.listItemSaved'),
            type: 'success'
          })
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
        .finally(() => {
          this.isUpdateItemLoading = false
          this.isUpdateItem = false
          this.refetch()
        })
    },
    refetch() {
      if (!this.serversLoading) {
        const body = {}
        if (this.$route.params.list_id !== undefined) {
          body.list_id = this.$route.params.list_id
        }
        const searchParams = new URLSearchParams(body)
        const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/list/items?${searchParams}`
        this.serversLoading = true
        fetch(url, {
          method: 'GET',
          credentials: 'include'
        })
          .then(res => {
            if (!res.ok) {
              throw res.json()
            }
            return res.json()
          })
          .then(data => {
            this.listItems = data.list_items
            this.columns = data.columns
            this.listConfig = data.list_config
            this.updateItemFields = data.list_item_fileds
            this.setListName(this.listConfig.name)
          })
          .catch(error =>
            error.then(data => {
              this.$notify({
                message: JSON.parse(data.message).message,
                type: 'danger'
              })
            })
          )
          .finally(() => {
            this.serversLoading = false
          })
      }
    },
    deleteListsItems(listItem_ids, msg) {
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/list/items/delete`
      return fetch(url, {
        credentials: 'include',
        body: JSON.stringify({
          list_id: this.$route.params.list_id,
          items_ids: listItem_ids
        }),
        method: 'POST'
      })
        .then(res => {
          if (!res.ok) {
            throw res.json()
          }
          return res.json()
        })
        .then(() => {
          this.$notify({
            message: this.$t('notification.removed', {
              msg: msg
            }),
            type: 'success'
          })
        })
        .catch(error =>
          error.then(data => {
            this.$notify({
              message: JSON.parse(data.message).message,
              type: 'danger'
            })
          })
        )
    },
    openDialogRemove() {
      if (!this.selected.length) {
        this.$notify({
          message: this.$t('notification.unselected'),
          type: 'danger'
        })
        return
      }
      const indexSet = new Set(this.selected)
      const listItems = this.listItems
        .filter(value => {
          return indexSet.has(value.id)
        })
        .map(d => {
          return d['Name']
        })
      const msg = listItems
        .map(d => {
          return d
        })
        .join(', ')

      this.$dialog.confirm({
        message: `${this.$t('confirm.remove', {
          msg: msg
        })}?`,
        onConfirm: () => {
          this.serversLoading = true
          this.deleteListsItems(this.selected, msg).finally(() => {
            this.serversLoading = false
            this.refetch()
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.item-modal-layout {
  h1 {
    font-size: large;
    font-weight: 900;
  }
  .parametrs-list {
    padding: 0.75rem 0;
  }
  .edit-button {
    display: flex;
    justify-content: right;
  }
}
</style>
